import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './B2B.css';
import { Link } from 'react-router-dom';

function B2B() {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [
    { src: "/images/cars/car.jpg", alt: "B2B 1" },
    { src: "/images/cars/car-2.jpg", alt: "B2B 2" },
    { src: "/images/cars/car-3.jpg", alt: "B2B 3" },
    { src: "/images/cars/car-4.jpg", alt: "B2B 4" },
    { src: "/images/nails/nails-2.jpg", alt: "B2B 5" },
    { src: "/images/nails/nails-3.jpg", alt: "B2B 6" },
    { src: "/images/nails/nails.jpg", alt: "B2B 7" },
    { src: "/images/nails/nails-5.jpg", alt: "B2B 8" },
    { src: "/images/hotelshooting-18.jpg", alt: "B2B 9" },
    { src: "/images/hotelshooting-19.jpg", alt: "B2B 10" },
    { src: "/images/hotelshooting-16.jpg", alt: "B2B 11" }
  ];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (selectedImage === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
      if (e.key === 'ArrowRight') handleNextImage();
      if (e.key === 'ArrowLeft') handlePrevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, images]);

  return (
    <div className="b2b-section">
      <Helmet>
        <title>Commercial Photography in Bristol | Business & Corporate Photography</title>
        <meta name="description" content="Professional commercial photography services in Bristol. Business portraits, corporate events, and product photography for companies across South West UK." />
        <meta name="keywords" content="commercial photography, business photography, corporate photography, Bristol commercial photographer, South West UK business photography" />
        <meta property="og:title" content="Commercial Photography in Bristol | Business & Corporate Photography" />
        <meta property="og:description" content="Professional commercial photography services in Bristol. Business portraits, corporate events, and product photography for companies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/services/b2b" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/services/b2b" />
      </Helmet>
      <div className="header-img-container">
        <img className="header-img" src="/images/hotelshooting-18.jpg" alt="B2B header" />
        <div className="header-img-overlay">
          <h1 className="header-title-mobile">B2B</h1>
          <p>Elevate your business with our professional photography and videography services.</p>
        </div>
      </div>
      <h1 style={{display:'none'}}>B2B</h1>
      <p style={{display:'none'}}>Professional B2B photography and videography to enhance your brand.</p>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <img key={index} className="gallery-img" src={image.src} alt={image.alt} onClick={() => handleImageClick(index)} />
        ))}
      </div>
      {selectedImage !== null && (
        <div className="album-modal-overlay" onClick={handleCloseModal}>
          <div className="album-modal" onClick={(e) => e.stopPropagation()}>
            <button className="album-close-btn" onClick={handleCloseModal}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={handlePrevImage}>&#8592;</button>
            <img className="album-image" src={images[selectedImage].src} alt={images[selectedImage].alt} />
            <button className="album-arrow album-arrow-right" onClick={handleNextImage}>&#8594;</button>
            <div className="album-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === selectedImage ? 'album-dot active' : 'album-dot'}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="gallery-cta">
  <h1>Commercial Photography & Video Services for Businesses in Bristol, Wales & the South West</h1>
  <p>
    Make your brand stand out with powerful visuals that tell your story. We offer professional B2B photography and video production tailored to businesses across Bristol, South West England, and Wales — helping you connect with your audience and elevate your image.
    <br /><br />
    Our services include:
    <br />
    - <strong>Product Photography</strong> – Clean, high-impact images for websites, catalogs, and e-commerce<br />
    - <strong>Social Media Reels & Short-Form Video</strong> – Eye-catching, on-brand content that drives engagement<br />
    - <strong>Car Photography</strong> – Striking automotive imagery for dealerships, showrooms, and private sellers<br />
    - <strong>Commercial Video Production</strong> – Promotional videos, business profiles, behind-the-scenes shoots, and more<br />
    - <strong>Professional Headshots</strong> – Clean, confident portraits for teams, executives, and personal branding<br />
    - <strong>On-Location Business Photography</strong> – Capture your workspace, team, or event in a way that reflects your brand
    <br /><br />
    Whether you're launching a new product, refreshing your online presence, or building content for social media and advertising, we deliver high-quality visuals that work.
    <br /><br />
    Let's create content that means business.
  </p>
  <Link to="/contact" className="gallery-cta-btn">Book Now</Link>
</div>


    </div>
  );
}

export default B2B; 